import { render, staticRenderFns } from "./LabelTextField.vue?vue&type=template&id=5dc4db18&scoped=true"
import script from "./LabelTextField.vue?vue&type=script&lang=js"
export * from "./LabelTextField.vue?vue&type=script&lang=js"
import style0 from "./LabelTextField.vue?vue&type=style&index=0&id=5dc4db18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc4db18",
  null
  
)

export default component.exports